import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import filterItems from "~libs/filterItems";
import SearcherList from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import getOpcionesDePago from "./js/getOpcionesDePago";

const useStyles = makeStyles((theme) => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    width: "100%",
    paddingTop: 10,
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
  },
}));

interface OpcionDePago {
  label: string;
  value: string;
}

interface FormaDePagoSelectorProps {
  onChange?: (value: string) => void;
}

const opcionesDePagoList: OpcionDePago[] = getOpcionesDePago();

const FormaDePagoSelector: React.FC<FormaDePagoSelectorProps> = ({
  onChange,
}) => {
  const [filter, setFilter] = useState<string>("");

  const handleItem = (item: { label: string | null; value: string | null }) => {
    setFilter("");
    if (!item?.value) {
      return;
    }

    onChange?.(item.value);
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  const classes = useStyles();

  return (
    <div className={classes.searcher}>
      <SearcherList
        onClear={() => setFilter("")}
        filter={filter}
        onChange={handleFilterChange}
        placeholder={"Buscar forma de pago"}
        borderBottomRounded={undefined}
      />
      <ListView
        onItemSelected={handleItem}
        list={
          filter === ""
            ? opcionesDePagoList
            : filterItems(opcionesDePagoList, filter)
        }
      />
    </div>
  );
};

export default FormaDePagoSelector;
